import styles from './styles.module.scss';

type Props = {
  children: React.ReactNode;
  /** 行クリック時のコールバック */
  onClick?: () => void;
};

export const TableRow: React.FC<Props> = ({ children, onClick }) => (
  <tr className={onClick ? styles.clickable : undefined} onClick={onClick}>
    {children}
  </tr>
);
